import React from 'react';
import styles from './features.module.scss';
import IconCheckSlim from '@dealroadshow/uikit-icon/IconCheckSlim';

const Features = () => (
  <div className={ styles.featuresWrp }>
    <ul className={ styles.featuresList }>
      <li className={ styles.feature }>
        <div className={ styles.featureIcon }><IconCheckSlim /></div>
        <div className={ styles.featureText }>20% savings guarantee</div>
      </li>
      <li className={ styles.feature }>
        <div className={ styles.featureIcon }><IconCheckSlim /></div>
        <div className={ styles.featureText }>Free 30-day trial period</div>
      </li>
      <li className={ styles.feature }>
        <div className={ styles.featureIcon }><IconCheckSlim /></div>
        <div className={ styles.featureText }>Free migration services</div>
      </li>
      <li className={ styles.feature }>
        <div className={ styles.featureIcon }><IconCheckSlim /></div>
        <div className={ styles.featureText }>
          Simple, transparent pricing with no hidden fees
        </div>
      </li>
      <li className={ styles.feature }>
        <div className={ styles.featureIcon }><IconCheckSlim /></div>
        <div className={ styles.featureText }>Easier to setup & manage</div>
      </li>
      <li className={ styles.feature }>
        <div className={ styles.featureIcon }><IconCheckSlim /></div>
        <div className={ styles.featureText }>Faster & more intuitive to use</div>
      </li>
      <li className={ styles.feature }>
        <div className={ styles.featureIcon }><IconCheckSlim /></div>
        <div className={ styles.featureText }>Industry leading analytics, available in perpetuity</div>
      </li>
      <li className={ styles.feature }>
        <div className={ styles.featureIcon }><IconCheckSlim /></div>
        <div className={ styles.featureText }>GDPR & SOC 2 Type II</div>
      </li>
      <li className={ styles.feature }>
        <div className={ styles.featureIcon }><IconCheckSlim /></div>
        <div className={ styles.featureText }>HIPAA compliant</div>
      </li>
      <li className={ styles.feature }>
        <div className={ styles.featureIcon }><IconCheckSlim /></div>
        <div className={ styles.featureText }>Fanatical 24x7x365 support</div>
      </li>
    </ul>
  </div>
);

export default Features;
